import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractCrudService } from '../../../shared/components/crud/abstract-crud.service';
import { RELATIVE_URL } from './crud-config';
import { Observable } from 'rxjs';
import { API_PATH } from 'src/environments/environment';
import { IPaginatedBillItemsResponse } from 'src/app/domain/registration/interfaces/bill-item.interface';
import { tap, map } from 'rxjs/operators';

@Injectable()
export class AccountsReceivableService extends AbstractCrudService {

  override title: string = 'Contas a Receber';
  override pluralTitle = 'Contas a Receber';

  constructor(protected override httpClient: HttpClient) {
    super(httpClient, RELATIVE_URL);
  }

  public findByFilter(filterForm: any, customerId: any, pagination: any): Observable<IPaginatedBillItemsResponse> {
    let params = {
      ...{ getRelation: 0, limit: 36, page: 0, filter: '', customerId },
      ...pagination,
    };

    return this.httpClient.post<IPaginatedBillItemsResponse>(
      `${API_PATH}${this.relativeUrl}/filter`,
      { ...filterForm, ...params }
    ).pipe(
      tap(response => console.log('Resposta bruta da API:', response)),
      map(response => {
        if (!response.items) response.items = [];
        return response;
      })
    );
  }

  public override listAll(filter: {}, customerId?: any): Observable<IPaginatedBillItemsResponse> {
    let params = {
      ...{ getRelation: 0, limit: 36, page: 0, filter: '', customerId },
      ...filter,
    };
    return this.httpClient.get<IPaginatedBillItemsResponse>(`${API_PATH}${this.relativeUrl}`, {
      params,
    });
  }

  public customersWithBillsFilter(filterForm: any, pagination: any): Observable<any> {
    let params = {
      ...{ getRelation: 0, limit: 36, page: 0, filter: '' },
      ...pagination,
    };

    let filters = filterForm ? { ...filterForm } : {};

    if (typeof filters === 'string') {
      const searchText = filters;
      filters = {
        name: searchText,
        document: searchText,
        email: searchText
      };
    }

    return this.httpClient.post<any>(
      `${API_PATH}${this.relativeUrl}/customers-with-bills-filter`,
      { ...filters, ...params }
    ).pipe(
      tap(response => {
        if (response?.items?.length === 0) {
          console.warn('Nenhum resultado encontrado com os filtros:', filters);
        }
      }),
      map(response => {
        if (!response.items) response.items = [];
        return response;
      })
    );
  }

  public cancel(ids: any, reason: string): Observable<any> {
    return this.httpClient.post(
      `${API_PATH}${this.relativeUrl}/bill-items/cancel`,
      { ids, reason }
    );
  }

  public pay(ids: any): Observable<any> {
    return this.httpClient.post(
      `${API_PATH}${this.relativeUrl}/bill-items/pay`,
      { ids }
    );
  }

  public unlink(ids: any, reason: string): Observable<any> {
    return this.httpClient.post(
      `${API_PATH}${this.relativeUrl}/bill-items/unlink`,
      { ids, reason }
    );
  }

  public reverse(ids: any): Observable<any> {
    return this.httpClient.post(
      `${API_PATH}${this.relativeUrl}/bill-items/reverse`,
      { ids }
    );
  }

  public getAccountsSummary(customerId?: string): Observable<{
    aReceber: number;
    venceHoje: number;
    recebido: number;
    vencidos: number;
    detalhes: {
      aReceber: Array<{
        cliente: string;
        valor: number;
        vencimento: string;
        status: string;
      }>;
      venceHoje: Array<{
        cliente: string;
        valor: number;
        status: string;
      }>;
      recebido: Array<{
        cliente: string;
        valor: number;
        DataCancelamento: string;
      }>;
      vencidos: Array<{
        cliente: string;
        valor: number;
        vencimento: string;
        diasAtraso: number;
      }>;
    };
  }> {
    const url = customerId
      ? `${API_PATH}${this.relativeUrl}/summary/${customerId}`
      : `${API_PATH}${this.relativeUrl}/summary`;
    return this.httpClient.get<any>(url);
  }

  public getMonthlyAdhesions(): Observable<any[]> {
    return this.httpClient.get<any[]>(`${API_PATH}${this.relativeUrl}/monthly-adhesions`);
  }

  public override update(id: string, data: any): Observable<any> {
    return this.httpClient.put(`${API_PATH}${this.relativeUrl}/bill-items/${id}`, data);
  }

  public createPaymentSlip(installmentId: string, paymentSlipData: any): Observable<any> {
    return this.httpClient.post(`${API_PATH}payments/payment-slips`, {
      installmentId,
      ...paymentSlipData
    });
  }

  public getPaymentSlip(paymentSlipId: string, refresh: boolean = false): Observable<any> {
    const params: any = {};
    if (refresh) {
      params.refresh = 'true';
    }
    return this.httpClient.get(`${API_PATH}payments/payment-slips/${paymentSlipId}`, { params });
  }

  public cancelPaymentSlip(paymentSlipId: string): Observable<any> {
    return this.httpClient.post(`${API_PATH}payments/payment-slips/${paymentSlipId}/cancel`, {});
  }

  public getPaymentSlipByInstallment(installmentId: string): Observable<any> {
    return this.httpClient.get(`${API_PATH}payments/payment-slips`, {
      params: { billItemId: installmentId }
    });
  }
}
